import $ from "jquery";

export const backgroundReplacer = () => {
    const elementList = $('.bg-lazy');

    if (!elementList.length) {
        return;
    }

    const observer = new IntersectionObserver(onIntersectionObserve);

    elementList.get().forEach(element => {
        observer.observe(element);
    });
};

const onIntersectionObserve = (entries, observer) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        }

        const url = $(entry.target).data('bg-image');

        if (url === undefined || url === '') {
            return;
        }

        $(entry.target).css('background-image', `url(${url})`);
        observer.unobserve(entry.target);
    });
};
